import { useState } from 'react'
import { BrandIfood, Brand99 } from './Brands'
import { linkWhatsApp } from '../config'

type Cartao = {
  chave: 'ifood' | '99'
  classe: string
  badge: string
  marca: React.ReactNode
  titulo: React.ReactNode
  sub: string
  checks: string[]
  listaClasse: string
  botao: string
  botaoClasse: string
  atraso?: string
}

const CARTOES: Cartao[] = [
  {
    chave: 'ifood',
    classe: 'pcard pcard--ifood',
    badge: 'pcard__badge has-logo',
    marca: <BrandIfood md />,
    titulo: <>Estruturação e Gestão<br /><span className="accent">de iFood</span></>,
    sub: 'Deixe sua loja no iFood pronta para atrair mais clientes e vender melhor. Cuidamos de todo o processo, do cadastro às estratégias de crescimento.',
    checks: ['Perfil otimizado', 'Gestão de anúncios (ADS)', 'Cardápio estratégico', 'Acompanhamento de desempenho', 'Imagens que vendem', 'Suporte contínuo', 'Precificação inteligente'],
    listaClasse: 'checks',
    botao: 'Quero dominar o iFood',
    botaoClasse: 'btn btn--primary btn--sm',
  },
  {
    chave: '99',
    classe: 'pcard pcard--99',
    badge: 'pcard__badge pcard__badge--99 has-logo',
    marca: <Brand99 md />,
    titulo: <>Estruturação e Gestão<br />de 99 Food</>,
    sub: 'Seu restaurante também no 99 Food, com uma estrutura profissional e estratégias para aumentar seus pedidos.',
    checks: ['Cadastro e configuração', 'Gestão de anúncios (ADS)', 'Cardápio otimizado', 'Acompanhamento de resultados', 'Imagens que vendem', 'Suporte especializado', 'Estratégia de preços'],
    listaClasse: 'checks checks--dark',
    botao: 'Quero dominar o 99 Food',
    botaoClasse: 'btn btn--dark btn--sm',
    atraso: '110',
  },
]

function Card({ dados }: { dados: Cartao }) {
  const [temFoto, setTemFoto] = useState(false)
  return (
    <article
      className={`${dados.classe}${temFoto ? ' has-photo' : ''}`}
      data-reveal="up"
      data-delay={dados.atraso}
      data-tilt
    >
      {/* Primeiro filho de proposito: o vel (::after) precisa ficar por cima
          da foto e embaixo do texto, e a ordem no DOM e o que define isso. */}
      <img
        className="pcard__photo"
        src={`/assets/img/card-${dados.chave}.webp`}
        alt=""
        onLoad={() => setTemFoto(true)}
      />
      <span className={dados.badge}>{dados.marca}</span>
      <div className="pcard__body">
        <h3>{dados.titulo}</h3>
        <p className="pcard__sub">{dados.sub}</p>
        <ul className={dados.listaClasse}>
          {dados.checks.map((c) => <li key={c}>{c}</li>)}
        </ul>
        <a href={linkWhatsApp()} className={dados.botaoClasse}>
          {dados.botao} <span className="arw">&rarr;</span>
        </a>
      </div>
    </article>
  )
}

export function Platforms() {
  return (
    <section className="platforms" id="plataformas">
      <div className="shell platforms__grid">
        {CARTOES.map((c) => <Card dados={c} key={c.chave} />)}
      </div>
    </section>
  )
}
